import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { svg } from '../assets/svg';
import { components } from '../components';
import { hooks } from '../hooks';
import { Routes } from '../routes';
import { RootState } from '../store';
import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage';
import SocialCards from './SocialCards';

type Props = {
  title?: string;
  userName?: boolean;
  userPhoto?: boolean;
  showGoBack?: boolean;
  showBasket?: boolean;
  headerStyle?: React.CSSProperties;
};

const modalMenu = [
  // {
  //   id: 1,
  //   title: 'Personal information',
  //   route: Routes.EditProfile,
  //   switch: false,
  // },
  {
    id: 8,
    title: 'About Us',
    route: Routes.AboutSection,
    switch: false,
  },
  // {
  //   id: 2,
  //   title: 'My orders',
  //   route: Routes.OrderHistory,
  //   // route: Routes.OrderHistoryEmpty,
  //   switch: false,
  // },
  // {
  //   id: 3,
  //   title: 'Promocodes & gift cards',
  //   route: Routes.Promocodes,
  //   // route: Routes.PromocodesEmpty,
  //   switch: false,
  // },
  // {
  //   id: 4,
  //   title: 'Notifications',
  //   route: '',
  //   switch: true,
  // },
  // {
  //   id: 5,
  //   title: 'Face ID',
  //   route: '',
  //   switch: true,
  // },
  // {
  //   id: 6,
  //   title: 'Support center',
  //   route: '',
  //   switch: false,
  // },
  // {
  //   id: 7,
  //   title: 'Sign out',
  //   route: Routes.SignIn,
  //   switch: false,
  // },
];

export const Header: React.FC<Props> = ({
  title,
  userName,
  userPhoto,
  showGoBack,
  showBasket,
  headerStyle,
}) => {
  const navigate = hooks.useNavigate();
  const location = hooks.useLocation();
  const MENU_CONFIG=getItemFromLocalStorage("menuConfiguration");

  const [showModal, setShowModal] = useState(false);
  const [themeColor, setThemeColor] = useState('#F6F9F9');

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');

    if (metaThemeColor && themeColor) {
      metaThemeColor.setAttribute('content', themeColor);
    }
  }, [themeColor, showModal]);
  const filteredMenu = modalMenu.filter(item => {
    if (item.id === 2 && !MENU_CONFIG?.isOrderFromAppSupported) {
      return false; // Hide "My Orders" if ordering is not supported
    }
    return true;
  });
  const cart = useSelector((state: RootState) => state.cartSlice);

  const renderUser = (): JSX.Element | null => {
    if (!userName && !userPhoto) return null;

    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          gap: 12,
          cursor: 'pointer',
          transition: 'opacity 0.2s ease',
        }}
        onClick={() => {
          setShowModal(true);
          setThemeColor('#fff');
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '0.8';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        <img
          alt='user'
          src={MENU_CONFIG?.logo}
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            objectFit: 'cover',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
        />
        {userName && (
          <h5 style={{
            margin: 0,
            fontSize: 14,
            fontWeight: 600,
            color: 'var(--main-color)',
          }}>
            {MENU_CONFIG?.restaurantName}
          </h5>
        )}
      </div>
    );
  };

  const renderGoBack = (): JSX.Element | null => {
    if (showGoBack && location.key !== 'default')
      return (
        <div
          onClick={() => navigate(-1)}
          style={{
            position: 'absolute',
            left: 0,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
          }}
          className='clickable'
        >
          <svg.GoBackSvg />
        </div>
      );

    return null;
  };

  const renderTitle = (): JSX.Element | null => {
    if (!title) return null;
    
    return (
      <div
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <span
          className='t16'
          style={{
            color: 'var(--main-color)',
            marginBottom: 2,
            display: 'block',
            fontWeight: 600,
            fontSize: 16,
            letterSpacing: '-0.2px',
          }}
        >
          {title}
        </span>
      </div>
    );
  };

  const renderBasket = (): JSX.Element | null => {
    if (!showBasket) return null;

    const itemCount = cart.list.length > 0 ? cart.list.length : 0;

    return (
      <button
        onClick={() => {
          navigate(Routes.Order);
        }}
        style={{
          height: '100%',
          width: 'auto',
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          right: 0,
          cursor: 'pointer',
          background: 'transparent',
          border: 'none',
          transition: 'opacity 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '0.7';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg.HeaderBasketSvg />
          {itemCount > 0 && (
            <div
              style={{
                position: 'absolute',
                backgroundColor: 'var(--main-turquoise)',
                padding: itemCount > 9 ? '4px 6px' : '4px 7px',
                borderRadius: '12px',
                top: -8,
                right: -12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: itemCount > 9 ? '24px' : '20px',
                height: '20px',
                boxShadow: '0 2px 6px rgba(0, 176, 185, 0.4)',
              }}
            >
              <span
                style={{
                  color: 'var(--white-color)',
                  fontFamily: 'DM Sans',
                  fontWeight: 700,
                  fontSize: 11,
                  lineHeight: 1,
                }}
              >
                {itemCount > 99 ? '99+' : itemCount}
              </span>
            </div>
          )}
        </div>
      </button>
    );
  };

  const renderModal = (): JSX.Element | null => {
    if (!showModal) return null;
    return (
      <>
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(12, 29, 46, 0.5)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            zIndex: 101,
            cursor: 'pointer',
            transition: 'opacity 0.3s ease',
          }}
          onClick={() => {
            setThemeColor('#F6F9F9');
            setShowModal(false);
          }}
        />
        <div
          style={{
            position: 'fixed',
            left: 0,
            top: 0,
            height: '100%',
            width: '80%',
            maxWidth: '320px',
            backgroundColor: 'var(--white-color)',
            zIndex: 102,
            boxShadow: '4px 0 24px rgba(0, 0, 0, 0.15)',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
        <div
          style={{
            paddingTop: '15%',
            paddingLeft: 24,
            paddingRight: 24,
            marginBottom: 24,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 16,
            paddingBottom: 24,
            borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
            textAlign: 'center',
            background: 'linear-gradient(180deg, rgba(246, 249, 249, 0.5) 0%, transparent 100%)',
          }}
        >
          <img
            src={MENU_CONFIG.logo}
            alt="restaurant"
            style={{
              width: 90,
              height: 90,
              borderRadius: 16,
              objectFit: 'cover',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          />
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 6,
          }}>
            <span
              style={{
                color: 'var(--main-color)',
                fontWeight: 600,
                fontSize: 16,
                marginBottom: 2,
              }}
            >
              {MENU_CONFIG.restaurantName || "DigiMenu"}
            </span>
            {MENU_CONFIG.restaurantAddress && (
              <span style={{
                color: 'var(--text-color)',
                fontSize: 13,
                lineHeight: 1.5,
              }}>
                {MENU_CONFIG.restaurantAddress}
              </span>
            )}
            {MENU_CONFIG.email && (
              <span style={{
                color: 'var(--text-color)',
                fontSize: 13,
              }}>
                {MENU_CONFIG.email}
              </span>
            )}
            {MENU_CONFIG.contactNumber && (
              <span style={{
                color: 'var(--main-turquoise)',
                fontSize: 13,
                fontWeight: 500,
              }}>
                {MENU_CONFIG.contactNumber}
              </span>
            )}
          </div>
        </div>

          <ul
            style={{
              paddingLeft: 24,
              paddingRight: 24,
              paddingBottom: 24,
              listStyle: 'none',
            }}
          >
            {filteredMenu.map((item, index, array) => {
              const isLast = index === array.length - 1;

              return (
                <li
                  key={item.id}
                  className='row-center-space-between clickable'
                  style={{
                    paddingTop: 12,
                    paddingBottom: 12,
                    marginBottom: isLast ? 0 : 4,
                    borderRadius: 8,
                    paddingLeft: 12,
                    paddingRight: 12,
                    transition: 'background-color 0.2s ease',
                  }}
                  onClick={() => {
                    if (item.route !== null) {
                      navigate(item.route);
                      setShowModal(false);
                      setThemeColor('#F6F9F9');
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(0, 176, 185, 0.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span
                    className='t16 number-of-lines-1'
                    style={{
                      color: item.title === 'Sign out' ? '#FA5555' : 'var(--main-color)',
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    {item.title}
                  </span>
                  {item.switch && <components.Switch />}
                </li>
              );
            })}
          </ul>
          <SocialCards/>
                    
        </div>
      </>
    );
  };

  return (
    <>
      <header
        style={{
          position: 'relative',
          height: 'var(--header-height)',
          backgroundColor: 'var(--white-color)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
          zIndex: 10,
          ...headerStyle,
        }}
        className='row-center-space-between'
      >
        {renderUser()}
        {renderGoBack()}
        {renderTitle()}
        {MENU_CONFIG?.isAddtoCartEnabled&&renderBasket()}
      </header>
      {renderModal()}
    </>
  );
};
